/**
 * Youtube
 * API: https://developers.google.com/youtube/iframe_api_reference?hl=zh-cn#Events
 */
export function useYoutube(params: {
    target: string | Element;
    youtubeSrc: string;
    height: string;
    width: string;
    stateChangeCallBack?: (state: number) => void;
}) {
    const baseYoutubeEl =
        typeof params.target === 'string' ? document.querySelector(params.target) : params.target;
    const videoId = youtubeParser(params.youtubeSrc);
    if (!videoId || !baseYoutubeEl) {
        return;
    }

    let player: any = null;

    if (!window.YT) {
        loadYoutubeJS();

        const mainTimer = setInterval(() => {
            if (window.YT && window.YT.Player) {
                clearInterval(mainTimer);
                videoId && baseYoutubeEl && onYouTubeIframeAPIReady();
            }
        }, 300);
    } else {
        onYouTubeIframeAPIReady();
    }

    // 2. This code loads the IFrame Player API code asynchronously.
    function loadYoutubeJS() {
        const tag = document.createElement('script');

        tag.src = 'https://ptxpublicres.ptengine.jp/scripts/video/ec-youtube.js';
        const firstScriptTag = document.getElementsByTagName('script')[0];
        firstScriptTag.parentNode?.insertBefore(tag, firstScriptTag);
    }

    // 3. This function creates an <iframe> (and YouTube player)
    //    after the API code downloads.
    function onYouTubeIframeAPIReady() {
        player = new window.YT.Player(baseYoutubeEl, {
            height: params.height,
            width: params.width,
            videoId,
            events: {
                onReady: onPlayerReady,
                onStateChange: onPlayerStateChange
            }
        });
    }

    // 4. The API will call this function when the video player is ready.
    function onPlayerReady(event) {
        // 取消自动播放
        // event.target.playVideo();
    }

    /**
     * The API calls this function when the player's state changes.
     * PlayerState: {
     *  "UNSTARTED": -1, //（未开始）
     *  "ENDED": 0, //（已结束）
     *  "PLAYING": 1, //（正在播放）
     *  "PAUSED": 2, //（已暂停）
     *  "BUFFERING": 3, //（正在缓冲）
     *  "CUED": 5 //（视频已插入）
     * }
     */
    function onPlayerStateChange(event) {
        typeof params.stateChangeCallBack === 'function' && params.stateChangeCallBack(event.data);
    }

    function stopVideo() {
        player.stopVideo();
        console.log('stopVideo --->');
    }
}

function youtubeParser(url: string) {
    var regExp = /^.*((youtu.be\/)|(v\/)|(\/u\/\w\/)|(embed\/)|(watch\?))\??v?=?([^#&?]*).*/;
    var match = url.match(regExp);
    return match && match[7].length == 11 ? match[7] : false;
}
